exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".admin-status-header{border-bottom:1px solid #ffffff40;margin-bottom:1.5rem;display:flex;justify-content:space-between}\n", ""]);

// exports
